import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';
import { SalesByProductConnection } from '@kaizenplatform/intelligence-entity';

export const startFetchingSalesByProduct = () =>
  produce((draft: Draft<State>) => {
    draft.salesByProduct.fetching = draft.salesByProduct.fetching + 1;
  });

export const setSalesByProduct = (salesByProductData: SalesByProductConnection) =>
  produce((draft: Draft<State>) => {
    draft.salesByProduct.data = salesByProductData;
  });

export const finishFetchingSalesByProduct = () =>
  produce((draft: Draft<State>) => {
    draft.salesByProduct.fetching = draft.salesByProduct.fetching - 1;
  });

export const disposeSalesByProduct = () =>
  produce((draft: Draft<State>) => {
    draft.salesByProduct.data = initialState.salesByProduct.data;
    draft.salesByProduct.fetching = initialState.salesByProduct.fetching;
  });
